module.exports = __webpack_public_path__ + "img/5_b.a78bd537.jpg";